
import { Component, Prop, Vue } from "vue-property-decorator";
import { OrderStatus } from "@/models";
import { SettingsOrderStatuses } from "@/services/SOLO";

@Component
export default class OrderStatusIsVisible extends Vue {
  @Prop() orderStatus!: OrderStatus;

  $notify: any
    
  async onChange(value: boolean) {
    try {
      const response = await SettingsOrderStatuses.update(this.orderStatus.id, {
        "is-visible-pickup": value
      });
    } catch (error) {
      console.error("Error:", error);
    }
  }
}
